<template>
	<Breadcrumb  class="breadcrumb-div">
		<BreadcrumbItem v-for="item in breadMenu" :to="item.link">{{item.name}}</BreadcrumbItem>
	</Breadcrumb>
</template>
<script>
	export default {
		name: 'CsBreadCrumb',
		props: ['breadMenu'],
		methods: {
		},
		mounted(){
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/breadcrumb/CsBreadCrumb.vue